import { useMemo } from "react";
import { useResolvedUserContext } from "@Front/Hooks/useResolvedUserContext";
import { isSuperAdminRole } from "@Front/Utils/officeRoleStatusHelpers";

type UseUserTypeDetectionResult = {
	isClientOrThirdParty: boolean;
	isSuperAdmin: boolean;
};

/**
 * Hook to detect user type (client, third party, super admin)
 */
export function useUserTypeDetection(): UseUserTypeDetectionResult {
	const { permissionContext, isThirdParty, isCustomer } = useResolvedUserContext();

	return useMemo(() => {
		if (!permissionContext) {
			return {
				isClientOrThirdParty: false,
				isSuperAdmin: false,
			};
		}

		const derivedIsSuperAdmin =
			permissionContext.isSuperAdmin === true || isSuperAdminRole(permissionContext.globalRole);

		return {
			isClientOrThirdParty: isThirdParty || isCustomer,
			isSuperAdmin: derivedIsSuperAdmin,
		};
	}, [isCustomer, isThirdParty, permissionContext]);
}
